import { render, staticRenderFns } from "./AttachmentCard.vue?vue&type=template&id=a2a56380&scoped=true"
import script from "./AttachmentCard.vue?vue&type=script&lang=js"
export * from "./AttachmentCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2a56380",
  null
  
)

export default component.exports